import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=0d5bf699&scoped=true"
import script from "./Paging.vue?vue&type=script&lang=ts"
export * from "./Paging.vue?vue&type=script&lang=ts"
import style0 from "./Paging.vue?vue&type=style&index=0&id=0d5bf699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5bf699",
  null
  
)

export default component.exports